<template>
  <form @submit.prevent="crearUsuario">
    <md-card>
      <md-card-header :data-background-color="dataBackgroundColor">
        <h4 class="title">Crear Usuario</h4>
        <p class="category">Completa los datos</p>
      </md-card-header>

      <md-card-content>
        <div class="md-layout">
          <!-- Nombres -->
          <div class="md-layout-item md-small-size-100 md-size-50">
            <md-field>
              <label>Nombres</label>
              <md-input v-model="nombre" type="text" required />
            </md-field>
          </div>

          <!-- Apellidos -->
          <div class="md-layout-item md-small-size-100 md-size-50">
            <md-field>
              <label>Apellidos</label>
              <md-input v-model="apellidos" type="text" required />
            </md-field>
          </div>

          <!-- Correo -->
          <div class="md-layout-item md-small-size-100 md-size-50">
            <md-field>
              <label>Correo</label>
              <md-input v-model="correo" type="email" required />
            </md-field>
          </div>

          <!-- Contraseña -->
          <div class="md-layout-item md-small-size-100 md-size-50">
            <md-field>
              <label>Contraseña</label>
              <md-input v-model="password" type="password" required />
            </md-field>
          </div>

          <!-- Cédula -->
          <div class="md-layout-item md-small-size-100 md-size-50">
            <md-field>
              <label>Cédula</label>
              <md-input v-model="cedula" type="text" required />
            </md-field>
          </div>

          <!-- Rol -->
          <div class="md-layout-item md-small-size-100 md-size-50">
            <md-field>
              <select v-model="rol" required class="custom-select">
                <option value="" disabled>Seleccione Rol</option>
                <option value="admin">Administrador</option>
                <option value="usuario">Usuario</option>
              </select>
            </md-field>
          </div>

          <!-- Regional -->
          <div class="md-layout-item md-small-size-100 md-size-50" v-if="regionales.length">
            <md-field>
              <select v-model="regional_id" required class="custom-select">
                <option value="" disabled>Seleccione Regional</option>
                <option v-for="reg in regionales" :key="reg.id" :value="reg.id">
                  {{ reg.nombre }}
                </option>
              </select>
            </md-field>
          </div>
          <div class="md-layout-item md-small-size-100 md-size-50" v-else>
            <md-field>
              <select disabled class="custom-select">
                <option>No hay regionales disponibles</option>
              </select>
            </md-field>
          </div>

          <!-- Botón -->
          <div class="md-layout-item md-size-100 text-right">
            <md-button type="submit" class="md-raised md-success">
              Crear Usuario
            </md-button>
          </div>
        </div>
      </md-card-content>
    </md-card>
  </form>
</template>

<script>
import Swal from 'sweetalert2';
export default {
  name: "crear-usuario-form",
  props: {
    dataBackgroundColor: {
      type: String,
      default: "",
    },
  },
  data() {
    return {
      nombre: "",
      apellidos: "",
      correo: "",
      password: "",
      cedula: "",
      rol: "",
      regional_id: "",
      regionales: [],
    };
  },
  mounted() {
    this.cargarRegionales();
  },
  methods: {
    async cargarRegionales() {
      try {
        const response = await this.$axios.get(
          "https://alexpruebas.tamep.bo/kqlurhnh_conciliacion/regional/listar_regionales.php"
        );
        console.log("Regionales cargadas:", response.data); // eslint-disable-line no-console
        this.regionales = response.data;
      } catch (error) {
        console.error("Error al cargar regionales:", error); // eslint-disable-line no-console
      }
    },
    async crearUsuario() {
      try {
        const response = await this.$axios.post(
          "https://alexpruebas.tamep.bo/kqlurhnh_conciliacion/user/crear_usuario.php",
          {
            nombre: this.nombre,
            apellidos: this.apellidos,
            correo: this.correo,
            password: this.password,
            cedula: this.cedula,
            rol: this.rol,
            regional_id: this.regional_id,
          }
        );

        if (response.data.error) {
          this.mostrarError(response.data.error);
        } else {
          Swal.fire({
            icon: "success",
            title: "¡Usuario creado!",
            text: "Usuario creado correctamente.",
            timer: 2000,
            showConfirmButton: false,
          });
          this.resetForm();
        }
      } catch (error) {
        this.mostrarError("Error al crear usuario.");
        console.error("Error al crear usuario:", error);// eslint-disable-line no-console
      }
    },
    resetForm() {
      this.nombre = "";
      this.apellidos = "";
      this.correo = "";
      this.password = "";
      this.cedula = "";
      this.rol = "";
      this.regional_id = "";
    },
    mostrarError(mensaje) {
      Swal.fire({
        icon: "error",
        title: "Oops...",
        text: mensaje,
      });
    },
  },
};
</script>

<style scoped>
.custom-select-wrapper {
  position: relative;
  display: inline-block;
  width: 100%;
}

.custom-select {
  -webkit-appearance: none;
  -moz-appearance: none;
  appearance: none;
  width: 100%;
  padding: 12px;
  border: 1px solid #ccc;
  border-radius: 4px;
  background-color: #fff;
  font-size: 16px;
  line-height: 1.5;
  background-image: url("data:image/svg+xml,%3Csvg viewBox='0 0 10 6' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='M0 0l5 6 5-6z' fill='%23999'/%3E%3C/svg%3E");
  background-repeat: no-repeat;
  background-position: right 10px center;
  background-size: 12px;
  transition: border-color 0.3s, box-shadow 0.3s;
}

.custom-select:focus {
  border-color: #3f51b5;
  outline: none;
  box-shadow: 0 0 0 2px rgba(63, 81, 181, 0.2);
}
</style>
